import { KYMW1310Model } from '../kymw1310.model';
import { KYMW1310PlanMultiPublishModel } from '../vo/kymw1310-plan-multi-publish.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';


/**
 * Ｗ掲載設定を登録・削除する
 *
 * @export API通信成功時の処理
 * @class GetUserInfomationDetailService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistPlanMultiPublishService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW1310Model;
  private successFunc: Function;
  private vo: KYMW1310PlanMultiPublishModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetUserInfomationDetailService
   */
  private getBody(): PlessRequest {

    const conditionList = [];
    // 多重掲載設定一覧
    for (let i = Number(0); i < this.vo.multiPublishList.length; i++) {
      if (this.vo.multiPublishList[i].publishFlagIB === true) {
        // 掲載フラグ（い）
        conditionList.push(this.createConditionData(
          this.vo.multiPublishList[i].mediumType,
          this.model.kymw1310Component.kymw00Model.COOP_CODE_IB
        ));
      }
      if (this.vo.multiPublishList[i].publishFlagTO === true) {
        // 掲載フラグ（と）
        conditionList.push(this.createConditionData(
          this.vo.multiPublishList[i].mediumType,
          this.model.kymw1310Component.kymw00Model.COOP_CODE_TO
        ));
      }
      if (this.vo.multiPublishList[i].publishFlagGU === true) {
        // 掲載フラグ（ぐ）
        conditionList.push(this.createConditionData(
          this.vo.multiPublishList[i].mediumType,
          this.model.kymw1310Component.kymw00Model.COOP_CODE_GU
        ));
      }
      if (this.vo.multiPublishList[i].publishFlagTI === true) {
        // 掲載フラグ（ち）
        conditionList.push(this.createConditionData(
          this.vo.multiPublishList[i].mediumType,
          this.model.kymw1310Component.kymw00Model.COOP_CODE_TI
        ));
      }
      if (this.vo.multiPublishList[i].publishFlagSA === true) {
        // 掲載フラグ（さ）
        conditionList.push(this.createConditionData(
          this.vo.multiPublishList[i].mediumType,
          this.model.kymw1310Component.kymw00Model.COOP_CODE_SA
        ));
      }
      if (this.vo.multiPublishList[i].publishFlagTK === true) {
        // 掲載フラグ（とう）
        conditionList.push(this.createConditionData(
          this.vo.multiPublishList[i].mediumType,
          this.model.kymw1310Component.kymw00Model.COOP_CODE_TK
        ));
      }
      if (this.vo.multiPublishList[i].publishFlagNA === true) {
        // 掲載フラグ（な）
        conditionList.push(this.createConditionData(
          this.vo.multiPublishList[i].mediumType,
          this.model.kymw1310Component.kymw00Model.COOP_CODE_NA
        ));
      }
      if (this.vo.multiPublishList[i].publishFlagNI === true) {
        // 掲載フラグ（に）
        conditionList.push(this.createConditionData(
          this.vo.multiPublishList[i].mediumType,
          this.model.kymw1310Component.kymw00Model.COOP_CODE_NI
        ));
      }
      if (this.vo.multiPublishList[i].publishFlagKU === true) {
        // 掲載フラグ（ク）
        conditionList.push(this.createConditionData(
          this.vo.multiPublishList[i].mediumType,
          this.model.kymw1310Component.kymw00Model.COOP_CODE_KU
        ));
      }
    }

    return new PlessRequest({
      regist: {
        PlanMultiPublish: {
          condition: {
            OrderCode: this.vo.orderCode,
            PCode: this.vo.pCode,
          },
          combination: conditionList
        }
      }
    })
  }

  /* 生協毎のconditionを作成する */
  private createConditionData(mediumType: string, coopCode: string) {
    return {
      condition: {
        MediumType: mediumType,
        CoopCode: coopCode,
      }
    }
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1310Model} model
   * @param {any} vo
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetUserInfomationDetailService
   */
  execute(model: KYMW1310Model, vo: KYMW1310PlanMultiPublishModel, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('registPlanMultiPublish', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetUserInfomationDetailService
   */
  success(data: any) {
    // 呼出元画面の一覧再表示メソッドを呼ぶ
    this.model.kymw1310Component.updateParent();
  }

}
